import PropTypes from "prop-types";
import { Card, Typography, LinearProgress, Box, useTheme } from "@mui/material";
import { fNumber } from "../../utils/formatNumber";
import StoreIcon from "../common/StoreIcon";

ProgressBarSummary.propTypes = {
  color: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      pct: PropTypes.number.isRequired,
      store: PropTypes.number.isRequired,
    })
  ).isRequired,
  total: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  sx: PropTypes.object,
};

export default function ProgressBarSummary({
  title,
  total,
  sx,
  data,
  color = "primary",
  ...other
}) {
  const theme = useTheme();
  return (
    <Card
      sx={{
        py: 2,
        px: 2,
        boxShadow: 0,
        textAlign: "center",
        ...sx,
      }}
      {...other}
    >
      <Typography variant="h5">
        {isNaN(total) ? total : fNumber(total)}
      </Typography>

      <Typography variant="subtitle4" sx={{ opacity: 0.72 }}>
        {title}
      </Typography>
      <Box sx={{ mt: 2 }}>
        {data.map((item, index) => (
          <Box key={index} sx={{ mb: 3 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <StoreIcon store={item.store} />
                <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
                  {item.title}
                </Typography>
              </Box>
              <Typography variant="body2" sx={{ fontSize: "0.875rem", fontWeight: 500 }}>
                {item.amount}
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={item.pct}
              sx={{
                height: 10,
                backgroundColor: theme.palette.action.hover,
                borderRadius: 2,
                "& .MuiLinearProgress-bar": {
                  backgroundColor: theme.palette[color].main,
                  borderRadius: 2,
                },
              }}
            />
          </Box>
        ))}
      </Box>

    </Card>
  );
}
